/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Showcase_Tagexperiment1Inputs */

const zh_showcase_tagexperiment1 = /** @type {(inputs: Showcase_Tagexperiment1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`虚拟实验`)
};

const en_showcase_tagexperiment1 = /** @type {(inputs: Showcase_Tagexperiment1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virtual Lab`)
};

const es_showcase_tagexperiment1 = /** @type {(inputs: Showcase_Tagexperiment1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lab Virtual`)
};

/**
* | output |
* | --- |
* | "Virtual Lab" |
*
* @param {Showcase_Tagexperiment1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const showcase_tagexperiment1 = /** @type {((inputs?: Showcase_Tagexperiment1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Showcase_Tagexperiment1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_showcase_tagexperiment1(inputs)
	if (locale === "en") return en_showcase_tagexperiment1(inputs)
	return es_showcase_tagexperiment1(inputs)
});
export { showcase_tagexperiment1 as "showcase_tagExperiment" }